export default {
	recommendedMaximumLength: 60,
	maximumLength: 80,
};
